import * as React from 'react';
import MarketsHeader from './markets-header';
import { MarketsHeaderCommonPublicProps } from './markets-header.models';
import { DisciplineIcon } from '@om-fe/widgets/dist/components/icon/discipline-icon';

interface MatchListMixedMarketsHeaderPublicProps extends MarketsHeaderCommonPublicProps {
    readonly disciplineName?: string;
    readonly disciplineId?: string;
}

type MatchListMixedMarketsHeaderProps = MatchListMixedMarketsHeaderPublicProps;

export default class MatchListMixedMarketsHeader extends React.PureComponent<MatchListMixedMarketsHeaderProps> {
    getTitleNode(): React.ReactNode {
        const { disciplineName, disciplineId } = this.props;

        if (!disciplineName || !disciplineId) {
            return null;
        }

        return (
            <>
                <DisciplineIcon disciplineId={disciplineId}/>
                <span className="DisciplineName">{disciplineName}</span>
            </>
        );
    }

    render(): React.ReactNode {
        return (
            <MarketsHeader
                {...this.props}
                title={this.getTitleNode()}
            />
        );
    }
}
